<template>
	<div class="container">
        <ul class="slide-items" ref="navSwiper">
            <li v-for="item in navList"
                :key="item.i"
                @click="handleClick($event, item)">
                <p :class="{'nav-active': currCid == item.name}">{{item[language]}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
import category from '@/config/categorys.js';
import utils from '@/utils/index.js';
import Swiper from '@/utils/swiper.js';
import storage from '@/utils/storage.js';
export default {
	data() {
		return {
			timeView: '',
			language: utils.loadLanguage()
		}
	},
	computed: {
		navList() {
			return category.list;
		},
		currCid() {
            return this.$route.params.cid;
        },
		query() {
			return this.$route.query;
		}
	},
    methods: {
		handleClick(e, nav) {
			this.$router.push({name: 'channel', params: {cid: nav.name}, query: {...this.query}});
			storage.setSession('navTransform', this.$refs.navSwiper.style.cssText);
		},
		loadNavScroll() {
			setTimeout(() => {
                if(this.$refs.navSwiper) {
                    new Swiper(this.$refs.navSwiper, true);
                }
            }, 300);
		}
    },
    mounted() {
		this.$nextTick(() => {
			this.loadNavScroll();
        });
    }
}
</script>


<style scoped>
.container {
    position: relative;
    overflow: hidden;
}
.slide-items {
    overflow-x: auto;
    white-space: nowrap;
	cursor: pointer;
}
.slide-items::-webkit-scrollbar {
    display: none;
}
.slide-items li {
	width: 1.8rem;
	text-align: center;
	font-family: DolceVitaHeavy-Bold;
	margin: 0.1rem 0;
    display: inline-table;
	opacity: 0.9;
	font-size: 0.12rem;
	color: #FFFFFF;
	letter-spacing: 0;
	font-weight: 700;
}
.slide-items li:nth-child(1) {
	/* margin: 0.1rem 0.4rem 0.1rem 0.2rem; */
}
.nav-active {
	width: 0.8rem;
	margin: 0 auto;
	position: relative;
	padding: 0.05rem 0.1rem;
	border-radius: 50px;
	background-image: linear-gradient(138deg, #ED4D8B 0%, #F05B4A 100%);
}
.nav-active:after {
	position: absolute;
	bottom: -15px;
	left: 50%;
	transform: translate(-50%, 0);
	content: ' ';
	border: 8px solid transparent;
	border-top: 8px solid #F05B4A;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Nav.vue